(function () {
  const buyBoxes = document.querySelectorAll(".buy-box");
  if (!buyBoxes.length) return;

  buyBoxes.forEach((buyBox) => {
    const buyBoxOptions = buyBox.querySelectorAll(".buy-box__option");
    const buyBoxButton = buyBox.querySelector(".buy-box__button");
    const buyBoxNotify = buyBox.querySelector(".buy-box__notify");
    const notifyButton = buyBox.querySelector(".buy-box__notify-button");
    const form = buyBox.querySelector(".buy-box__notify-form");

    if (buyBoxOptions.length) {
      function updateButtonFromCheckedOption() {
        const checkedOption = buyBox.querySelector(
          ".buy-box__option input:checked",
        );

        if (checkedOption && checkedOption.dataset.fullPrice) {
          const fullPrice = checkedOption.dataset.fullPrice;
          buyBoxButton.innerHTML = `<span>Add to Bag</span><span>·</span><span><s>£${fullPrice}</s> £${checkedOption.value}</span>`;
        } else if (checkedOption) {
          buyBoxButton.innerHTML = `<span>Add to Bag</span><span>·</span><span>£${checkedOption.value}</span>`;
        }
      }

      updateButtonFromCheckedOption();

      buyBoxOptions.forEach((option) => {
        option.addEventListener("click", updateButtonFromCheckedOption);
      });
    }

    if (notifyButton && form) {
      notifyButton.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        buyBoxNotify.classList.toggle("visible");
      });

      initEmailForm(form);
    }
  });
})();
